import React from 'react';
import { CompanyName } from '../../utils/Constants';

function NameHeaderComponent() {
  return (
    <section className='grid items-center pt-12'>
      <h1 className='text-6xl lg:text-9xl tracking-widest font-titleFont text-colour7'>
        {CompanyName}
      </h1>
    </section>
  );
}

export default NameHeaderComponent;
